declare global {
  interface Window {
    rg4js: any
  }
}

export default function useRaygun() {
  return window.rg4js
}
